<template>
  <ClientRequestsBoard type="PHONE" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ClientRequestsBoard from "./ClientRequestsBoard.vue";

export default defineComponent({
  name: "PhoneRequests",
  components: { ClientRequestsBoard },
});
</script>
